import { render, staticRenderFns } from "./ClientListDropdown.vue?vue&type=template&id=eddeab98&"
import script from "./ClientListDropdown.vue?vue&type=script&lang=js&"
export * from "./ClientListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports